<template>
	<i class="material-icons" :style="style">{{ icon }}</i>
</template>

<script>
export default {
	props: {
		icon: {
			type: String,
			required: true
		},
	},
	components: {},
	data() {
		return {
			loading: false,
		}
	},
	computed: {
		style() {
			let style = '';
			if (this.color) style = `color: ${this.color};`
			return style
		}

	},
	methods: {},
	mounted() {
	}
}
</script>

<style>
</style>
